import {useQueries, useQuery} from "@tanstack/react-query";
import {useAppFwContext} from "../AppFwContextContextProvider.tsx";
import {User} from "../api-client/AppFwApiClient.ts";
import {useCallback} from "react";

export const useUser = (id: string) => {
    const appFwContext = useAppFwContext()
    return useQuery({
        queryKey: ['users', id],
        queryFn: () => appFwContext.appFwApiClient.getUser({id}),
        staleTime: 1000 * 60 * 60,
    })
}

export const useUsers = (ids: string[]) => {
    const appFwContext = useAppFwContext()
    return useQueries({
        queries: ids.map((id) => {
            return {
                queryKey: ['users', id],
                queryFn: () => appFwContext.appFwApiClient.getUser({id}),
                staleTime: 1000 * 60 * 60, // 1h
            }
        }),
    })
}

export function useLoadUser() {
    const appFwContext = useAppFwContext()
    return useCallback(async (id: string): Promise<User | null> => {
        return appFwContext.queryClient.fetchQuery({
            queryKey: ['users', id],
            queryFn: () => appFwContext.appFwApiClient.getUser({id}),
            staleTime: 1000 * 60 * 60, // 1h
        })
    }, [appFwContext.appFwApiClient, appFwContext.queryClient])
}